export default class PersonHighSchoolDomainService {
    static fromJSON(personHighSchool) {
        return Object.assign(Object.assign({}, personHighSchool), { startDate: personHighSchool.startDate && new Date(personHighSchool.startDate), endDate: personHighSchool.endDate && new Date(personHighSchool.endDate), highSchoolTranscriptDate: personHighSchool.highSchoolTranscriptDate &&
                new Date(personHighSchool.highSchoolTranscriptDate) });
    }
}
